module.exports = __webpack_public_path__ + "static/img/baijiahao.b76b7a3e.png";